
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useA4FPromptEnhancement = () => {
  const [isEnhancing, setIsEnhancing] = useState(false);

  const enhancePrompt = async (originalPrompt: string): Promise<string | null> => {
    if (!originalPrompt.trim()) {
      toast.error('Please enter a prompt to enhance');
      return null;
    }

    setIsEnhancing(true);

    try {
      const { data, error } = await supabase.functions.invoke('enhance-prompt-a4f', {
        body: { prompt: originalPrompt }
      });

      if (error) throw error;

      if (data?.enhancedPrompt) {
        toast.success('Prompt enhanced successfully with A4F!');
        return data.enhancedPrompt;
      } else {
        throw new Error('No enhanced prompt received');
      }
    } catch (error) {
      console.error('Error enhancing prompt with A4F:', error);
      toast.error('Failed to enhance prompt. Please try again.');
      return null;
    } finally {
      setIsEnhancing(false);
    }
  };

  return {
    enhancePrompt,
    isEnhancing
  };
};
